import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { pasteNumberOnly } from '../../../utils/input-number/input-number';
import { environment } from '../../../../environments/environment';

const imgixHost = environment.imgixHost;
const customCss = `
    .country-flag:after {
      background-image: url('${imgixHost}/website/countries-flags/flag-sprite.png');
    }
  `;

const GERMANY_ISO2_CODE = 'DE';
const GERMANY_DIALING_CODE = '+49';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./flags.scss', '../auth-modal/auth-modal.component.scss', './phone-number.component.scss'],
  styles: [customCss],
  standalone: false
})
export class PhoneNumberComponent implements OnInit {
  phoneCodes = [];
  filteredPhoneCodes = [];
  showCountryCodePicker = false;
  selectedCode = '';
  selectedFlag = GERMANY_ISO2_CODE;
  objectKeys;
  phoneNumber: string;
  searchModel = GERMANY_DIALING_CODE;
  searchField: ElementRef;

  @Input() set defaultValue(phone: string) {
    this.phoneNumber = '';
    phone && (this.phoneNumber = phone);
  }
  @Input() cssModifier = '';
  @Input() set defaultSelectedCode(selectedCode: string) {
    this.selectedCode = selectedCode ? selectedCode : GERMANY_DIALING_CODE;
    this.selectedFlag = this.getCountryFromPhoneCode(this.selectedCode);
  }
  @Input() id: string;
  @Input() phoneValid;
  @Input() tabindex: number;
  @Input() showRequiredAsterisk: boolean;
  @Output() phoneChanged: EventEmitter<string> = new EventEmitter();

  @ViewChild('searchField') set content(content: ElementRef) {
    if (content) {
      this.searchField = content;

      if (this.showCountryCodePicker) {
        this.searchField.nativeElement.focus();
      }
    }
  }

  constructor(private readonly elemRef: ElementRef) {
    this.objectKeys = Object.keys;
    this.getCountriesPhoneCodes();
  }

  ngOnInit() {}

  @HostListener('document:click', ['$event'])
  clickOutsideDropDown(event) {
    if (!this.elemRef.nativeElement.contains(event.target)) {
      if (this.showCountryCodePicker) {
        this.showHideCountryCodePicker();
      }
    }
  }

  enterPhone() {
    if (this.phoneNumber && this.phoneNumber != '') {
      this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, '');
    }
    if (this.phoneNumber && this.phoneNumber != '') {
      this.phoneChanged.emit(this.selectedCode + ' ' + this.phoneNumber);
    } else {
      this.phoneChanged.emit('');
    }
  }
  getCountriesPhoneCodes() {
    this.phoneCodes = this.sortProperties(require(`projects/lime-main/src/assets/countries/phone-codes.json`));
    this.filteredPhoneCodes = [...this.phoneCodes];
  }

  sortProperties(obj) {
    let sortable = [];
    for (let key in obj) if (obj.hasOwnProperty(key)) sortable.push([key, obj[key]]);

    sortable.sort(function (a, b) {
      let x = a[1].toLowerCase(),
        y = b[1].toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });
    return sortable;
  }

  onChange() {
    this.enterPhone();
  }
  onPaste(event: ClipboardEvent) {
    pasteNumberOnly(event);
    this.enterPhone();
  }
  showHideCountryCodePicker() {
    this.showCountryCodePicker = !this.showCountryCodePicker;

    if (!this.showCountryCodePicker && this.searchModel.length > 0) {
      this.clearSearchField();
    }
  }
  selectCode(country: string[]) {
    this.selectedCode = country[1];
    this.selectedFlag = country[0];
    this.showCountryCodePicker = false;

    if (this.phoneNumber && this.phoneNumber != '') {
      this.phoneChanged.emit(this.selectedCode + ' ' + this.phoneNumber);
    }
  }

  getCountryFromPhoneCode(value): string {
    let selectedFlag: string;

    this.phoneCodes.map((item) => {
      if (item[1] === value) {
        selectedFlag = item[0];
      }
    });

    return selectedFlag;
  }
  searchCodes(e: KeyboardEvent): void {
    const numbersPlusOrHyphenPattern = new RegExp('[0-9+-]');
    const isValidKey =
      numbersPlusOrHyphenPattern.test(e.key) || e.key.toLowerCase() === 'backspace' || e.key.toLowerCase() === 'shift';
    if (isValidKey) {
      this.filteredPhoneCodes = this.phoneCodes.filter((item) => item[1].indexOf(this.selectedCode) !== -1);
    } else {
      this.selectedCode = this.selectedCode.slice(0, -1);
    }
  }
  clearSearchField(): void {
    this.selectedCode = '';
    this.filteredPhoneCodes = [...this.phoneCodes];
    this.phoneChanged.emit(null);
  }

  trackByFilteredPhoneCodes(index, item) {
    return item[0];
  }
}
